<template>
    <div class="oido-address-input">

        <ion-label class="composite-label" v-text="label" v-if="label"></ion-label>

        <div class="validation-errors" v-if="false && errors">
            <span class="validation-error" v-for="error of errors" v-text="error" :key="error"></span>
        </div>

        <div class="input-section" v-if="localValue">


            <div class="input-line isCompany" v-if="!hideTypeSelector">
                <div class="validation-errors" v-if="errors && errors.isCompany">
                    <span class="validation-error" v-for="error of errors.isCompany" v-text="error" :key="error"></span>
                </div>

                <ion-radio-group class="address-type-group" v-model="localValue.isCompany">
                    <ion-radio mode="md" :value="false" label-placement="end" :alignment="'center'" justify="start"
                        v-text="$t('address-input-type-individual')"></ion-radio>
                    <ion-radio mode="md" :value="true" label-placement="end" :alignment="'center'" justify="start"
                        v-text="$t('address-input-type-company')"></ion-radio>
                </ion-radio-group>

            </div>




            <div class="input-line">
                <div class="validation-errors" v-if="errors && errors.name">
                    <span class="validation-error" v-for="error of errors.name" v-text="error" :key="error"></span>
                </div>

                <ion-input
                    :label="$t(localValue.isCompany ? 'address-input-companyname-label' : 'address-input-name-label')"
                    label-placement="floating" v-if="localValue" name="name" type="text"
                    :placeholder="$t(localValue.isCompany ? 'address-input-companyname-placeholder' : 'address-input-name-placeholder')"
                    v-model="localValue.name" :class="{
                        'has-errors': errors && (errors.name || errors.global),
                    }" />

            </div>

            <div class="input-line"
                v-if="localValue.isCompany || (localValue.countryCode == 'ES' && !isDeliveryAddress)">

                <div class="validation-errors" v-if="errors && errors.vatId">
                    <span class="validation-error" v-for="error of errors.vatId" v-text="error" :key="error"></span>
                </div>

                <ion-input :label="$t('address-input-vat-id-label')" label-placement="floating" v-if="localValue"
                    name="vatId" type="text" :placeholder="$t('address-input-vat-id-placeholder')"
                    v-model="localValue.vatId" :class="{
                        'has-errors': errors && (errors.vatId || errors.global),
                    }" />

            </div>

            <div class="input-line">

                <div class="validation-errors" v-if="errors && errors.street">
                    <span class="validation-error" v-for="error of errors.street" v-text="error" :key="error"></span>
                </div>

                <ion-input :label="$t('address-input-street-label')" label-placement="floating" v-if="localValue"
                    name="street" type="text" :placeholder="$t('address-input-street-placeholder')"
                    v-model="localValue.street" :class="{
                        'has-errors': errors && (errors.street || errors.global),
                    }" />

            </div>

            <div class="input-line">
                <div class="validation-errors" v-if="errors && errors.zip">
                    <span class="validation-error" v-for="error of errors.zip" v-text="error" :key="error"></span>
                </div>
                <ion-input :label="$t('address-input-zip-label')" label-placement="floating" v-if="localValue"
                    name="zip" type="text" :placeholder="$t('address-input-zip-placeholder')" v-model="localValue.zip"
                    :class="{
                        'has-errors': errors && (errors.zip || errors.global),
                    }" />
            </div>

            <div class="input-line">
                <div class="validation-errors" v-if="errors && errors.city">
                    <span class="validation-error" v-for="error of errors.city" v-text="error" :key="error"></span>
                </div>
                <ion-input :label="$t('address-input-city-label')" label-placement="floating" v-if="localValue"
                    name="city" type="text" :placeholder="$t('address-input-city-placeholder')"
                    v-model="localValue.city" :class="{
                        'has-errors': errors && (errors.city || errors.global),
                    }" />
            </div>

            <div class="input-line">

                <div class="validation-errors" v-if="errors && errors.countryCode">
                    <span class="validation-error" v-for="error of errors.countryCode" v-text="error"
                        :key="error"></span>
                </div>

                <OidoCountrySelector v-if="localValue" v-model="localValue.countryCode"
                    :class="{ 'has-errors': errors && (errors.countryCode || errors.global) }"
                    :label="$t('address-input-country-label')"></OidoCountrySelector>

            </div>

        </div>

    </div>
</template>

<script setup>

import OidoCountrySelector from "./OidoCountrySelector.vue";

import {
    IonRadio,
    IonRadioGroup,
    IonLabel,
    IonInput
} from "@ionic/vue";


</script>

<script>

export default {
    props: {
        errors: [Array, Object],
        modelValue: Object,
        label: [String],
        defaultCountry: [String],
        hideTypeSelector: Boolean,
        isDeliveryAddress: Boolean

    },
    components: {},
    data() {
        return {
            localValue: {
                isCompany: false,
                countryCode: null,
                name: null,
                street: null,
                zip: null,
                city: null,

            },
        }
    },
    computed: {

    },
    mounted() {
        this.modelValueChanged()
    },
    watch: {
        modelValue: {
            deep: true,
            handler: function () {
                this.modelValueChanged()
            },
        },
        localValue: {
            deep: true,
            handler: function () {
                this.localValueChanged()
            },
        }
    },
    methods: {
        isEmpty(address) {
            return !address || Object.keys(address).length == 0 || (
                (!address.name || !address.name.length > 0) &&
                (!address.street || !address.street.length > 0) &&
                (!address.zip || !address.zip.length > 0) &&
                (!address.city || !address.city.length > 0) &&
                (!address.countryCode || !address.countryCode.length > 0)
            )
        },

        modelValueChanged() {

            //do nothing in case both are empty
            if (this.isEmpty(this.modelValue) && this.isEmpty(this.localValue)) {
                return
            }

            if (typeof this.modelValue == 'undefined') {
                return
            }

            if (JSON.stringify(this.localValue) != JSON.stringify(this.modelValue)) {
                this.localValue = JSON.parse(JSON.stringify(this.modelValue))
            }

        },
        localValueChanged() {
            let value = this.localValue
            if (JSON.stringify(value) != JSON.stringify(this.modelValue)) {
                this.$emit("update:modelValue", JSON.parse(JSON.stringify(value)));
            }
        }
    }

}
</script>
<style scoped>
.oido-address-input {
    padding-top: 1rem;
    padding-bottom: 1rem;
}

.composite-label {
    display: block;
    padding-top: 0.5rem;
    margin-bottom: 0rem;
    font-size: 1rem;
    font-weight: 200;
}

.input-line:last-of-type {
    border-bottom: none !important;
}

.input-line.isCompany {
    border-bottom: none;
    margin-bottom: 0rem;
    margin-top: 0.5rem;
}

ion-radio-group {
    display: flex;
    justify-content: center;
    padding: 1rem 2rem;
}

ion-radio {
    display: inline-block;
}

ion-radio:first-child {
    margin-right: 3rem;
}


.input-line {
    display: flex;
    flex-direction: column;
    border-bottom: 1px solid #ddd;
    margin-left: 0.1rem;
    margin-bottom: 0.5rem;
}

.input-line ion-input {
    --padding-start: 0.9rem;
}

.input-line ion-input label {
    text-align: left !important;
}

.input-line .validation-errors {
    text-align: left;
    margin-left: 0.8rem;
}

.oido-country-selector {
    margin: 0.5rem 0.05rem 1rem;
}
</style>
<style>
.oido-address-input ion-input {
    text-align: left;
}

.oido-address-input .oido-country-selector ion-label {
    padding-left: 0.8rem;
    margin-bottom: 0.8rem;
}

.oido-address-input ion-radio::part(label) {
    margin-left: 0.5rem;
    margin-bottom: -.1rem;
}
</style>